import { envConfig } from '@globals/env'
import { loadGainsightPx } from '@globals/gainsightPx'
import { initAPI } from '@kudos/http-client'
// eslint-disable-next-line local/require-direct-mui-imports
import { LicenseInfo } from '@mui/x-license'
import FroalaEditor from 'froala-editor'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { App } from './App'

// Initialize the API with base URL and default locale for this environment
initAPI({ apiUrl: envConfig.API_URL, apiLocale: 'en' })

// Set the license key for the MUI X pro components
LicenseInfo.setLicenseKey(envConfig.MUI_PRO_KEY)

// Set the license key for Froala enterprise
FroalaEditor.DEFAULTS.key = envConfig.FROALA_ENTERPRISE_KEY

// Install the Gainsight PX tag (no-op outside the production deploy).
loadGainsightPx()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
